<div class="audio-controls">
    <button mat-button class="mat-button-icon" (click)="toggleVolumeSlider()" disableRipple><span
            class="mdi mdi-volume-high"></span></button>
    <!-- <div class="volume-slider-container" [ngClass]="{'volume-slider-on': volumeSliderVisible, 'volume-slider-off': !volumeSliderVisible}"> -->
    <div class="volume-slider-container" [hidden]="!volumeSliderVisible">
        <mat-slider class="w-100" min="0" max="1" step="0.1" [(ngModel)]="currentVolume" thumbLabel="false" (change)="volumeChange()">
        </mat-slider>
    </div>
</div>